<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="productSpec"
      >
        <div class="flex items-center">
          <img
            v-if="productSpec.imageUrl && productSpec.imageUrl !== ''"
            width="40"
            :src="productSpec.imageUrl"
            class="mr-4"
          />
          <img v-else width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Assign recipe to venue</h4>
            <small v-if="productSpec.name"
              >{{ productSpec.name }} (by
              {{ productSpec.createdBy.username }})</small
            >
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Select venue</span>
            </div>
            <div>
              <venue-selector
                v-model="filterVenue"
                @venue="onVenueSelected"
                :filterCountries="[activeCountry.name]"
                :globalMode="true"
                :multiple="false"
              />
              <vs-button class="mt-3" color="success" @click="confirmAssign">
                Assign
              </vs-button>
            </div>
          </div>

          <!--  -->
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="closeSidebar"> Go back </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/shout-icon.png";
import { mapGetters } from "vuex";
import PopupAddProduct from "./PopupAddProduct.vue";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: {
    VenueSelector,
    VuePerfectScrollbar,
    PopupAddProduct,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      productSpec: null,
      filterVenue: null,
    };
  },
  computed: {
    ...mapGetters({
      activeCountry: "venues/activeCountry",
    }),
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    onVenueSelected(venue) {
      console.log("Selected venue", venue);
    },
    closeSidebar() {
      this.isActive = false;
      this.isLoading = false;
    },
    async show(productSpec) {
      this.isActive = true;
      this.isLoading = true;

      var result = await this.$store.dispatch(
        "productSpecs/getProductSpec",
        productSpec
      );

      this.productSpec = result;

      console.log("Got product spec", this.productSpec);
      this.isLoading = false;
    },

    async confirmAssign() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Assign this recipe to the venue?`,
        accept: this.assign,
      });
    },
    async assign() {
      console.log("Assigning DTO", this.productSpec.id, this.filterVenue);

      const dto = {
        productSpecIds: [this.productSpec.id],
      };

      const result = await this.$store.dispatch("pimVenues/assignProductSpec", {
        venueId: this.filterVenue,
        dto: dto,
      });

      this.$vs.notify({
        title: "Recipe assigned",
        text: "Product recipe successfully assigned to venue.",
      });

      this.isActive = false;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>